<button class="ant-btn ant-btn-primary d-flex align-items-center" (click)="configMode == 'basic' ? configMode = 'advanced' : configMode = 'basic'">
    <i nz-icon nzType="setting" nzTheme="outline"></i> 
    <span>{{(configMode == 'basic' ? 'cau_hinh_nang_cao' : 'cau_hinh_co_ban') | translate}}</span>
</button>
<!-- Cấu hình cơ bản -->
<ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
        <div class="config-name" style="flex-direction: column;">
            <p>{{'chon_trang_khi_nhan_vao_san_pham' | translate}}</p>
            <nz-select [(ngModel)]="staticdata.page_link_enter"
                    (ngModelChange)="updateObject()"
                    nzPlaceHolder="{{'chon_lien_ket' | translate}}" allowClear
                    [disabled]="false">
                    <nz-option [nzValue]="null" nzLabel=""></nz-option>
                    <nz-option *ngFor="let page of arr_link_page" [nzValue]="page._id || ''"
                    [nzLabel]="page['name_' + functionService.selectedLanguageCode] ?? page.name"></nz-option>
             </nz-select>
        </div>

        <div class="config-name">
            <p class="title">{{'dong_tat_ca_khoi_hop_thoai_dang_mo' | translate}}</p>
            <nz-switch 
                [(ngModel)]="config['is_close_all_modal_on_search']"
                (ngModelChange)="updateConfig()"></nz-switch>
        </div>
    </div>
</ng-container>

<!-- UI desktop -->
<div class="contains-main" *ngIf="!isViewAll && configMode == 'advanced'">
  <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Hiển thị -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
          <div class="main-config">
              <!-- Lựa chọn hiển thị cho các thiết bị -->
              <app-hide-show-config
                  [device]="device"
                  [elementChoosing]="objectChoosing">
              </app-hide-show-config>
          </div>
      </li>
      <!-- Ẩn hiện chức năng -->
      <li nz-submenu nzTitle="{{'an_hien_chuc_nang' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
          <div class="main-config">
              <div class="switch-image">
                  <p class="title">{{'an_nut_tim_kiem' | translate}}</p>
                  <nz-switch 
                  [(ngModel)]="config['format_button']['hide_button_search']"
                  (ngModelChange)="updateConfig()"></nz-switch>
              </div>
              <div class="switch-image">
                  <p class="title">{{'an_ket_qua_tim_kiem' | translate}}</p>
                  <nz-switch 
                      [(ngModel)]="config['format_search_result']['hide_data_enabled']" 
                      (ngModelChange)="updateConfig()"></nz-switch>
              </div>
              <ng-container *ngIf="config['format_search_result']['hide_data_enabled']">
                  <p class="config-message">
                      {{'config_message' | translate}}
                  </p>

              </ng-container>
              <!-- Hiện frame cho user thiết kế -->
              <ng-container *ngIf="!config['format_search_result']['hide_data_enabled']">
                  <div class="switch-image">
                      <p class="title">{{'hien_khung_ket_qua_cho_thiet_ke' | translate}}</p>
                      <nz-switch 
                          [(ngModel)]="config['format_search_result']['show_result_design']" 
                          (ngModelChange)="updateConfig()"></nz-switch>
                  </div>

              </ng-container>
          </div>
      </li>
      <!-- Cấu hình ô tìm kiếm -->
      <li nz-submenu nzTitle="{{'cau_hinh_o_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
          <div class="main-config">
              <ul nz-menu nzMode="inline">
                  <!-- Định dạng chữ gợi ý -->
                  <li nz-submenu nzTitle="{{'noi_dung_chu_goi_y' | translate}}">
                      <div class="container-font">
                          <div class="config-text" style="width: 100%">
                              <mat-form-field style="width: 100%">
                                  <mat-label>{{'noi_dung_chu_goi_y' | translate}}</mat-label>
                                  <textarea style="padding-top: 7px" matInput 
                                      [ngModel]="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_placeholder' : objectChoosing.component" 
                                      (ngModelChange)="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] = $event" 
                                      (blur)="updateStaticData()"></textarea>
                              </mat-form-field>
                          </div>

                          <app-text-format-config
                              [device]="device"
                              [objectChoosing]="objectChoosing"
                              [class]="class"
                              [config]="config"
                              [staticdata]="staticdata"
                              [textContentClass]="class['search-customize-box__input-placeholder']"
                              [textWrapperClass]="class['search-customize-box__input-placeholder']"
                              >
                          </app-text-format-config>
                      </div>
                  </li>
                  <!-- Định dạng chữ khi nhập -->
                  <li nz-submenu nzTitle="{{'dinh_dang_chu_khi_nhap' | translate}}">
                      <app-text-format-config
                              [device]="device"
                              [objectChoosing]="objectChoosing"
                              [class]="class"
                              [config]="config"
                              [staticdata]="staticdata"
                              [textContentClass]="class['search-customize-box__input']"
                              [textWrapperClass]="class['search-customize-box__input']"
                              >
                      </app-text-format-config>
                  </li>
                  <!-- Định dạng ô -->
                  <li nz-submenu nzTitle="{{'dinh_dang_o' | translate}}">
                      <ul nz-menu nzMode="inline">
                          <li nz-submenu nzTitle="{{'tuy_chinh_kieu_vien_tim_kiem' | translate}}">
                              <div class="main-config">
                                  <app-borders-config 
                                              [elementChoosing]="objectChoosing"
                                              [device]="device"
                                              [class]="class"
                                              [borderClass]="class['search-customize-box__input']"
                                              [id_object]="objectChoosing._id"
                                              >
                                  </app-borders-config>
                                  
                                  <!-- Nút mở rộng -->
                                  <div class="config-name view-more-btn">
                                      <p (click)="openViewAll(stylefields[0])">{{'mo_rong' | translate}} &#8594;</p>
                                  </div>
                              </div>
                              
                          </li>
                          <!-- Bật đổ bóng -->
                          <li nz-submenu nzTitle="{{'do_bong_o_tim_kiem' | translate}}">
                              <app-shadow-config 
                                  [device]="device"
                                  [config]="config"
                                  [class]="class"
                                  [shadowClass]="class['search-customize-box']"
                                  [shadowConfig]="config['search_box_shadow']"
                                  [objectChoosing]="objectChoosing"
                                  >
                              </app-shadow-config>
                              
                          </li>
                          <!-- Khoảng cách với nút tìm kiếm -->
                          <li nz-submenu nzTitle="{{'khoang_cach_voi_nut_tim_kiem' | translate}}">
                              <div style="padding-left: 5px;">
                                  <div class="config-name mb-0">
                                      <p>{{'khoang_cach' | translate}}</p>
                                      <nz-input-number [nzMin]="0" [nzMax]="200" [nzStep]="1"
                                        [ngModel]="class['search-customize-box']['gap'] | vhnumber"
                                        (ngModelChange)="class['search-customize-box']['gap'] = $event + 'px'"
                                        (nzBlur)="updateClass()">
                                      </nz-input-number>
                                  </div>
                                  <nz-slider [nzMin]="0" [nzMax]="200" [nzStep]="1"
                                    [ngModel]="class['search-customize-box']['gap'] | vhnumber"
                                    (ngModelChange)="class['search-customize-box']['gap'] = $event + 'px'"
                                    (nzOnAfterChange)="updateClass()">
                                  </nz-slider>
                              </div>
                          </li>
                      </ul>
                  </li>
                  <!-- Nhãn ô -->
                  <li nz-submenu nzTitle="{{'nhan_o' | translate}}">
                    <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
                        <mat-label>{{'nhan_o' | translate}}<span style="color: red">*</span></mat-label>
                        <textarea matInput
                        [ngModel]="staticdata.accessibility?.['aria_label_input_' + functionService.selectedLanguageCode]"
                        (ngModelChange)="staticdata.accessibility['aria_label_input_' + functionService.selectedLanguageCode] = $event"
                        (blur)="updateStaticData();"></textarea>
                    </mat-form-field>
                </li>
              </ul>
          </div>
          
      </li>
      <!-- Cấu hình nút tìm kiếm -->
      <li nz-submenu nzTitle="{{'cau_hinh_nut_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
          <!-- Vị trí nút -->
          <!-- <div class="switch-image twins">
              <mat-form-field style="width: 100%;">
                  <mat-label>Chọn vị trí</mat-label>
                  <mat-select [(ngModel)]="objectChoosing[device+'_format_button'].position_button" (ngModelChange)="updateCss(device+'_format_button', objectChoosing[device+'_format_button']);">
                      <mat-option *ngFor="let options of positionOptions" [value]="options.value">{{options.label}}</mat-option>
                  </mat-select>
              </mat-form-field>
          </div> -->
          <div class="main-config">
              <ul nz-menu nzMode="inline">
                  <!-- Cấu hình format font name của button -->
                  <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}">
                      <div class="item-symbol">
                          <p class="title" style="line-height: 1.5">{{'an_bieu_tuong_van_ban' | translate}}</p>
                          <nz-switch [(ngModel)]="config['format_button_text']['hide_button_search']" (ngModelChange)="updateConfig()"></nz-switch>
                      </div>
                      <!-- <div class="d-flex justify-content-between mx-1">
                          <mat-icon>{{ config["format_button_text"]['name'] }}</mat-icon>
                          <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px"
                              [disabled]="config['format_button_text']['hide_button_search']">
                              Thay đổi
                          </button>
                      </div> -->
                      <div *ngIf="!config['format_button_text']['hide_button_search']">
                          <div class="container-font">
                              <div class="config-text" style="width: 100%">
                                  <mat-form-field style="width: 100%">
                                      <mat-label>{{'tieu_de_nut' | translate}}</mat-label>
                                      <textarea style="padding-top: 7px" matInput 
                                          [ngModel]="config['format_button_text']['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                                          (ngModelChange)="config['format_button_text']['content_' + functionService.selectedLanguageCode] = $event" 
                                          (blur)="updateConfig()"></textarea>
                                  </mat-form-field>
                              </div>
                              <div class="config-font-size">
                                  <div class="field-row-font" style="width: 65%">
                                      <mat-form-field style="width: 100%">
                                          <mat-label>Font</mat-label>
                                          <mat-select [(ngModel)]="
                                              class['search-customize-box__button-text']['font-family']
                                              " (ngModelChange)="updateClass()" [(value)]="class['search-customize-box__button-text']['font-family']">
                                          <mat-option *ngFor="let font of fontsListItem" [value]="font.value">{{
                                              font.label
                                              }}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </div>
                                  <div class="field-row-size" style="width: 35%">
                                      <mat-form-field style="width: 100%">
                                          <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                                          <input matInput type="number" [ngModel]="
                                              class['search-customize-box__button-text']['font-size'] | vhnumber
                                              " (ngModelChange)="
                                              class['search-customize-box__button-text']['font-size'] =
                                                  $event + 'px'
                                              " />
                                      </mat-form-field>
                                  </div>
                              </div>
                              <div class="config-font">
                                  <p class="title-font">{{'kieu_chu' | translate}}</p>
                                  <div class="field-row">
                                      <div style="display:flex; width: 80%">
                                          <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                                              class['search-customize-box__button-text']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                                              (click)="
                                              class['search-customize-box__button-text']['font-weight'] =
                                              class['search-customize-box__button-text']['font-weight'] == 'bold' ? '500' : 'bold';updateClass()">
                                              <span style="font-weight: 600">B</span>
                                          </button>
                                          <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                                  class['search-customize-box__button-text']['font-style'] == 'italic'
                                                  ? 'primary'
                                                  : 'default'
                                              " (click)="
                                                  class['search-customize-box__button-text']['font-style'] =
                                                  class['search-customize-box__button-text']['font-style'] == 'normal'
                                                      ? 'italic'
                                                      : 'normal';
                                                  updateClass()
                                              ">
                                              <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                                          </button>
                                          <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                                  class['search-customize-box__button-text']['text-decoration'] ==
                                                  'underline'
                                                  ? 'primary'
                                                  : 'default'
                                              " (click)="
                                                  class['search-customize-box__button-text']['text-decoration'] =
                                                  class['search-customize-box__button-text']['text-decoration'] ==
                                                  'none'
                                                      ? 'underline'
                                                      : 'none';
                                                  updateClass()
                                              ">
                                              <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                                          </button>
                                          <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                                  class['search-customize-box__button-text']['text-transform'] ==
                                                  'uppercase'
                                                  ? 'primary'
                                                  : 'default'
                                              " (click)="
                                                  class['search-customize-box__button-text']['text-transform'] =
                                                  class['search-customize-box__button-text']['text-transform'] ==
                                                  'none'
                                                      ? 'uppercase'
                                                      : 'none';
                                                  updateClass()
                                              ">
                                              <span>AB</span>
                                          </button>
                                      </div>
                                      
                                      <div style="width: 15%;">
                                          <input id="color" type="button"
                                          [cpOKButton]="true" [(colorPicker)]="class['search-customize-box__button-text']['color']"
                                          [style.background]="class['search-customize-box__button-text']['color']" (colorPickerClose)="updateObject()"/>
                                      </div>
                                  </div>
                              </div>
                              <div class="font-adjusting">
                                  <div class="row-spacing">
                                      <span class="title">{{'gian_cach_chu' | translate}}</span>
                                      <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                                              class['search-customize-box__button-text']['letter-spacing'] | vhnumber
                                          " (nzBlur)="updateClass()" (ngModelChange)="
                                              class['search-customize-box__button-text']['letter-spacing'] =
                                              $event + 'px'
                                          "></nz-input-number>
                                  </div>
                                  <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                                          class['search-customize-box__button-text']['letter-spacing'] | vhnumber
                                          " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                                          class['search-customize-box__button-text']['letter-spacing'] =
                                              $event + 'px'
                                          "></nz-slider>
                              </div>
                          </div>
                      </div>
                      
                  </li>
                  <!-- Cấu hình biểu tượng -->
                  <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
                      <app-symbol-config
                          [device]="device"
                          [class]="class"
                          [config]="config"
                          [symbolClass]="class['search-customize-box__button']"
                          [fontSizeIconClass]="class['search-customize-box__button-icon']"
                          [symbolConfig]="config['format_icon_search']"
                          [objectChoosing]="objectChoosing">
                      </app-symbol-config>
                      
                  </li>
                  <!-- chọn màu nền button -->
                  <li nz-submenu nzTitle="{{'chon_mau_nen_nut' | translate}}">
                      <div class="container-color">
                          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                            [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
                            [disabled]="config['background-color'].gradient_check"></button>
                      </div>
                      <div class="config-name" style="padding-left: 5px;">
                          <p>{{'mau_nen_nut' | translate}}</p>
                          <input class="input-color" type="button"
                              [style.background]="class['search-customize-box__button']['background-color']"
                              [cpOKButton]="true" [(colorPicker)]="class['search-customize-box__button']['background-color']"
                              (colorPickerClose)="updateClass()" />
                      </div>
                      <!-- Nút mở rộng -->
                      <div class="config-name view-more-btn">
                          <p (click)="openViewAll(stylefields[3])">{{'mo_rong' | translate}} &#8594;</p>
                      </div>
                      <!-- Mở popup so sánh màu tương phản -->
                    <button *ngIf="!config['format_button']['hide_button_search'] && !config['format_button_text']['hide_button_search']"
                    nz-row (click)="openColorContrast()" nz-tooltip
                    [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
                    style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
                        {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
                    </button>
                  </li>
                  <!-- "Chỉnh kích thước nút -->
                  <li nz-submenu nzTitle="Chỉnh kích thước nút">
                      <div style="padding-left: 5px;">
                          <div class="config-name mb-0">
                              <p>{{'kich_thuoc_nut' | translate}}</p>
                              <nz-input-number [nzMin]="1" [nzMax]="200" [nzStep]="1"
                                [ngModel]="class['search-customize-box__button']['width'] | vhnumber"
                                (ngModelChange)="class['search-customize-box__button']['width'] = $event + 'px'"
                                (nzBlur)="updateClass()">
                              </nz-input-number>
                          </div>
                          <nz-slider [nzMin]="1" [nzMax]="200" [nzStep]="1"
                            [ngModel]="class['search-customize-box__button']['width'] | vhnumber"
                            (ngModelChange)="class['search-customize-box__button']['width'] = $event + 'px'"
                            (nzOnAfterChange)="updateClass()">
                          </nz-slider>
                      </div>
                  </li>
                  <!-- tùy chỉnh viền button-->
                  <li nz-submenu nzTitle="Kiểu viền button">
                      <div style="padding-left: 5px;">
                          <app-borders-config [elementChoosing]="objectChoosing"
                                              [device]="device"
                                              [class]="class"
                                              [borderClass]="class['search-customize-box__button']"
                                              [id_object]="objectChoosing._id"
                          >
                          </app-borders-config>
                          <!-- Nút mở rộng -->
                          <div class="config-name view-more-btn">
                              <p (click)="openViewAll(stylefields[1])">{{'mo_rong' | translate}} &#8594;</p>
                          </div>
                      </div>
                      
                  </li>
                  <!-- Nhãn nút -->
                  <li nz-submenu nzTitle="{{'nhan_nut' | translate}}">
                    <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
                        <mat-label>{{'nhan_nut' | translate}}<span style="color: red">*</span></mat-label>
                        <textarea matInput
                        [ngModel]="staticdata.accessibility?.['aria_label_btn_' + functionService.selectedLanguageCode]"
                        (ngModelChange)="staticdata.accessibility['aria_label_btn_' + functionService.selectedLanguageCode] = $event"
                        (blur)="updateStaticData();"></textarea>
                    </mat-form-field>
                </li>
              </ul>
          </div>
          
      </li>
      
      <!-- Kết nối trang tìm kiếm -->
      <li nz-submenu nzTitle="{{'ket_noi_trang_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
         
          <div class="config-name" style="flex-direction: column;">
              <p>{{'chon_trang_khi_nhan_vao_san_pham' | translate}}</p>
              <nz-select [(ngModel)]="staticdata.page_link_enter"
                      (ngModelChange)="updateObject()"
                      nzPlaceHolder="{{'chon_lien_ket' | translate}}" allowClear
                      [disabled]="false">
                      <nz-option [nzValue]="null" nzLabel=""></nz-option>
                      <nz-option *ngFor="let page of arr_link_page" [nzValue]="page._id || ''" [nzLabel]="page['name_' + functionService.defaultLanguage]"></nz-option>
               </nz-select>
          </div>
      </li>

      <!-- SỰ KIỆN KHI TÌM KIẾM -->
      <li nz-submenu [nzTitle]="'su_kien_khi_tim_kiem' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
          <div class="config-name">
              <p class="title">{{'dong_tat_ca_khoi_hop_thoai_dang_mo' | translate}}</p>
              <nz-switch 
                  [(ngModel)]="config['is_close_all_modal_on_search']"
                  (ngModelChange)="updateConfig()"></nz-switch>
          </div>
      </li>

      
  </ul>
</div>

<div class="editor-content" *ngIf="isViewAll">
  <div
    class="return"
    (click)="isViewAll = !isViewAll"
    style="
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      margin-bottom: 5px;
    "
  >
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll" 
            style="font-weight: 500;">
          {{currentViewAll.title | translate}}</span>
  </div>
</div>

<div class="view-more" *ngIf="isViewAll">
  <!-- Cấu hình chi tiết viền của ô tìm kiếm -->
  <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config 
                  [elementChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [borderRadiusClass]="class['search-customize-box__input']"
                  [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
  </div>

  <!-- Cấu hình chi tiết viền của button-->
  <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config 
                  [elementChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [borderRadiusClass]="class['search-customize-box__button']"
                  [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
  </div>

  <!-- Cấu hình chi tiết viền của item result -->
  <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config
                  [elementChoosing]="objectChoosing"
                  [device]="device"
                  [class]="class"
                  [borderRadiusClass]="class['search-customize-result__item--border']"
                  [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
  </div>
  <!-- Cấu hình chi tiết màu gradient  -->
  <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color']['gradient_check']"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" 
        *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color']['gradient_check']">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" 
        [ngStyle]="{ 'cursor': config['background-color']['gradient_check'] ? 'pointer': 'not-allowed'}"
          [cpOKButton]="true" [(colorPicker)]="class['search-customize-box__button']['background-color']" type="button"
          [disabled]="!config['background-color']['gradient_check']"
          [style.background]="class['search-customize-box__button']['background-color']" (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" 
          *ngFor="let type of typeGradient" nz-tooltip [nzTooltipTitle]="type.name"
          (click)="chooseOption(type, $event)" [disabled]="!config['background-color']['gradient_check']" [style.background]="
            'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"></button>
  </div>
  
   <!-- Cấu hình chi tiết viền của result -->
   <div class="view_more-border" *ngIf="currentViewAll.index == 6">
      <app-borders-radius-config
          [elementChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [borderRadiusClass]="class['search-customize-result']"
          [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
  </div>
</div>
